<template>
  <div

    class="fit-out__history"
  >
    <template v-if="completedFitOuts.length">
      <HKLLeftRight
        v-for="(item, index) in completedFitOuts"
        :key="index"
        class="fit-out__history-item align-middle"
      >
        <div
          class="fit-out__history-title"
          @click="() => openPreviousHistory(item)"
        >
          {{ $t('tenantProjects.greenFitOut.title') }} {{ item.number }}
        </div>
        <HKLGrayHint>
          {{ item.tipWording }}
        </HKLGrayHint>
      </HKLLeftRight>
      <GreenFitOutPreviewSendModal
        ref="previewSendModal"
        :previewData="previewFitOut"
      />
    </template>
    <div
      v-if="isTenant && isUnderReview"
      class="fit-out__history-item row align-middle align-spaced"
    >
      <div class="green-fitout-comments__title font-bold column small-6">
        {{ $t('tenantProjects.greenFitOut.title') }}
      </div>
      <div class="tip column small-6">
        <span class="tip__text">{{ $t('tenantProjects.submission.comment.underReview') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useRefModal } from '@/controls/Modal/modal.hook'
import GreenFitOutPreviewSendModal from '@/modules/tenantProjects/greenFitOut/GreenFitOutPreviewSendModal'
import HKLLeftRight from '@/controls/Layout/HKLLeftRight'
import HKLGrayHint from '@/controls/HKLGrayHint'
import { useStoreGetters } from '@/store/index'
import dateUtil from '@/utils/dateUtil'
import { computed } from '@vue/composition-api'
import lodash from 'lodash'
import { getCurrentInstance, ref } from 'vue-demi'
import { GREEN_FITOUT_HISTORY_ACTION_TYPE, GREEN_FITOUT_STATUS } from './consts'
import { useGreenFitoutSubmissions, useCurrentGreenFitoutStatus } from './hook'
import { useProjectId } from '../postFitOutLetter/hook'
export default {
  components: {
    HKLLeftRight,
    HKLGrayHint,
    GreenFitOutPreviewSendModal,
  },
  setup () {
    const userStore = useStoreGetters('user', ['isHKlandUser', 'isTenant'])
    const { proxy } = getCurrentInstance()
    const { isUnderReview } = useCurrentGreenFitoutStatus()
    const projectId = useProjectId()
    const { data: allFitOuts } = useGreenFitoutSubmissions(projectId)
    const completedFitOuts = computed(() => {
      const result = allFitOuts.value.filter(item => item.status === GREEN_FITOUT_STATUS.COMPLETED)
      return lodash.orderBy(result, ['createdAt'], ['desc']).map((item) => {
        return {
          ...item,
          number: item.order ? item.order + 1 : '',
          tipWording: setUpTipWording(item.histories),
        }
      })
    })
    const setUpTipWording = (histories) => {
      const shouldFilteredActionType = [GREEN_FITOUT_HISTORY_ACTION_TYPE.SEND]
      if (userStore.isHKlandUser.value) {
        shouldFilteredActionType.push(GREEN_FITOUT_HISTORY_ACTION_TYPE.RESEND)
      }
      const latestHistory = lodash.orderBy(histories, 'createdAt', 'desc').filter(item => shouldFilteredActionType.includes(item.actionType))[0] || {}
      const templateParamArray = getActionHistoryInfo(latestHistory)
      const tipWordingMaps = {
        [GREEN_FITOUT_HISTORY_ACTION_TYPE.SEND]: 'tenantProjects.submission.sentByOn',
        [GREEN_FITOUT_HISTORY_ACTION_TYPE.RESEND]: 'tenantProjects.submission.resentByOn',
      }
      if (userStore.isTenant.value) {
        Object.assign(tipWordingMaps, {
          [GREEN_FITOUT_HISTORY_ACTION_TYPE.SEND]: 'tenantProjects.submission.receivedOn',
        })
        templateParamArray.shift()
      }
      return proxy.$t(tipWordingMaps[lodash.get(latestHistory, 'actionType')], templateParamArray)
    }

    const getActionHistoryInfo = (history) => {
      const displayName = lodash.get(history, 'createdBy.displayName', proxy.$t('emptyValue'))
      const actionTime = dateUtil.formatDate(lodash.get(history, 'createdAt'), true)
      return [displayName, actionTime]
    }

    const previewFitOut = ref(null)
    const previewSendModal = useRefModal()
    const openPreviousHistory = (item) => {
      previewFitOut.value = item
      previewSendModal.open()
    }

    return {
      ...userStore,
      allFitOuts,
      isUnderReview,
      previewFitOut,
      completedFitOuts,
      openPreviousHistory,
      previewSendModal: previewSendModal.modal,

    }
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.fit-out__history-item {
  display: flex;
  justify-content: space-between;
  border: 1px solid #e0e1e4;
  color: #0c3a58;
  padding: 9px 14px 11px 17px;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  .hkl-gray-hint {
    font-size: 11px;
  }
}
.fit-out__history-title {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
</style>
